export enum SoundType {
    OK = 'ok.wav',
    ERROR = 'error.wav',
    WARNING = 'warning.wav',
}
